import React from "react";
import { Col, Row } from "react-bootstrap";
const SlideNewsGeneric = (props) => {
    var _a, _b, _c;
    return (React.createElement("div", { className: `sliderNewsblock ${props.parentClass ? props.parentClass : ""}` },
        React.createElement(Row, { className: "m-0" },
            React.createElement(Col, { lg: 12, className: "flexJustifySpaceBetween p-0" },
                React.createElement(Col, { className: "d-flex" },
                    React.createElement("span", { className: "researchtag EncodeSans_10_500 flexCenter" }, "N"),
                    React.createElement("span", { className: "EncodeSans_14_600 txt_blackOne1 ps-2 slidenewsgeneric" }, props.title)),
                React.createElement(Col, { className: "EncodeSans_10_500 txt_primaryGrey taRight slidenewsgenericdate" }, props.news && ((_a = props.news) === null || _a === void 0 ? void 0 : _a.date)))),
        props.news &&
            ((_b = props.news) === null || _b === void 0 ? void 0 : _b.content) &&
            ((_c = props.news) === null || _c === void 0 ? void 0 : _c.content.map((item, i) => {
                if ((props === null || props === void 0 ? void 0 : props.limit) ? i < props.limit : true)
                    return (React.createElement(Col, { key: i, className: "news-block EncodeSans_12_600 txt_blackOne1 newscontent-block" },
                        React.createElement("span", { className: "dpname" },
                            " ",
                            item.customElements.displayName),
                        React.createElement("span", null, " : "),
                        React.createElement("span", { className: "d-ln-text2-content" }, item.description)));
            }))));
};
export default SlideNewsGeneric;
